<template>
    <v-container class="grey lighten-5 px-0 pt-0 pb-2" style="width:100%">
        <v-sheet dense v-for="(item,i) in rules" :key="i" class="d-flex flex-row flex-nowrap" color="extraLightGrey">
                <v-row dense>
                    <v-col :cols="getCols(item)" class="d-flex align-center">
                        <span class="mr-2 pr-4 text--primary"><translation-container :context="this" value="If"></translation-container></span>
                        <v-select outlined dense background-color="white"
                                :label="Translate('Operator')"
                                v-model="item.operator"
                                :items="condition_types"
                                item-text="text"
                                item-value="value"
                                :menu-props="{ offsetY: true }"
                                @change="updateReport"
                                hide-details
                                :rules="operatorRules"
                                :error-messages="operatorErrorMessages"
                                :error="operatorErrorMessages.length > 0"></v-select>
                    </v-col>
                    <v-col cols="4" class="d-flex align-center" v-if="!(item.operator == 'empty' || item.operator == 'notEmpty' || item.operator == 'missing')">
                        <v-text-field outlined dense background-color="white"
                                      :label="Translate('Value')"
                                      v-model="item.value"
                                      @input="updateReport"
                                    hide-details
                                    :rules="valueRules"
                                    :error-messages="valueErrorMessages"
                                    :error="valueErrorMessages.length > 0"></v-text-field>
                    </v-col>

                    <v-col cols="4" class="d-flex align-center">
                        <span class="mx-2 text--primary"><translation-container :context="this" value="then"></translation-container></span>
                        <ThresholdformatOptions :EventBus="EventBus" :defaultColor="value.color" @thresholdFormatChanged="thresholdFormatChanged"/>
                    </v-col>                    
                </v-row>

            </v-sheet>
    </v-container>
</template>

<script>
    import _ from 'lodash';
    import methods from '@/Shared/methods';

    import ThresholdformatOptions from './threshold_formatOptions.vue';

    export default {
        
        components: {
            ThresholdformatOptions
        },
        data: function () {
            return {
                rules: [{ condition: 'contains', value: '', combiner: undefined }],
                operatorErrorMessages: [],
                valueErrorMessages: [],
            }
        },
        props: {
            item: Object,
            value: null,
            EventBus: null
        },
        created() {
            if (this.value)
            {
                console.log(`threshold_searchableTextColumn has received an initialValue of ${JSON.stringify(this.value)}`);
            }
            const self = this;
            this.updateReportDebouncer = _.debounce(function () {
                if (self.rules[0].operator == 'missing' || self.rules[0].operator == 'empty' || self.rules[0].operator == 'notEmpty')
                {
                    self.rules[0].value = "";
                }

                if (self.rules.length == 1)
                {
                    // Single rule scenario is the simplest format (made popular by ag-grid)
                    self.$emit('thresholdValuesChanged', {
                        filterType: "text",
                        operator: self.rules[0].operator,
                        filter: self.rules[0].value,
                        value: self.rules[0].value,
                        type: "searchableText"
                    });
                }
                else
                {
                    // Multiple rule scenario puts the conditions into an array
                    self.$emit('thresholdValuesChanged', {
                        filterType: "text",
                        operator: self.rules[0].combiner,
                        type: "searchableText",
                        conditions: self.rules.map(a => ({
                            type: a.condition,
                            filter: a.value,
                        }))
                    });
                }

            }, 500);
            if (this.value && this.value.type) {
                this.rules = [{
                    operator: this.value.operator,
                    value: this.value.value,
                }];
            }
            else if (this.value && this.value.conditions && this.value.conditions.length == 2) {
                this.rules = [{
                    condition: this.value.conditions[0].operator,
                    value: this.value.conditions[0].value,
                    combiner: this.value.operator,
                }, {
                    condition: this.value.conditions[1].operator,
                    value: this.value.conditions[1].value,
                }];
            }
        },
        watch: {
            rules: function (newv) {
                this.updateReport();
            },
        },
        computed: {
            condition_types: function() {
                return [
                    { text: this.Translate('Equals'), value: 'equals' },
                    { text: this.Translate('Does Not Equal'), value: 'notEquals' },
                    { text: this.Translate('Contains'), value: 'contains' },
                    { text: this.Translate('Does Not Contain'), value: 'notContains' },
                    { text: this.Translate('Begins With'), value: 'beginsWith' },
                    { text: this.Translate('Ends With'), value: 'endsWith' },
                    { text: this.Translate('Blank'), value: 'empty' },
                    { text: this.Translate('Not Blank'), value: 'notEmpty' },
                    { text: this.Translate('Missing'), value: 'missing' },
                ];
            },
            valueRules() {
                return [
                    v => !!v || this.Translate('Please enter a value')
                ];
            },
            operatorRules() {
                return [
                    v => !!v || this.Translate('Please select an operator')
                ];
            },            
        },
        methods: {
            ...methods,
            updateReport() {
                this.updateReportDebouncer();
            },
            setItemCombiner(item, index, value) {
                item.combiner = value;
                this.updateReport();
            },
            addCondition() {
                this.rules.push({ condition: 'contains', value: '', combiner: undefined });
            },
            removeCondition() {
                this.rules.pop();
            },  
            thresholdFormatChanged(message){
                this.$emit('thresholdFormatChanged', message);
            },
            getCols: function(item) {
                    const currentOperator = item.operator;
                    if (currentOperator === 'missing' || currentOperator == 'empty' || currentOperator == 'notEmpty') {
                        return 8; // Take up more space when 'missing'
                    }
                    return 4; // Default size for other operators
            },            
            triggerValidation() {
                this.operatorErrorMessages = [];
                this.valueErrorMessages = [];

                for (const rule of this.operatorRules) {
                    const result = rule(this.item.operator);
                    if (typeof result === 'string') {
                        this.operatorErrorMessages.push(result);
                        break; // Stop at the first error
                    }
                }

                if(!(this.item.operator == 'empty' || this.item.operator == 'notEmpty' || this.item.operator == 'missing')){
                    for (const rule of this.valueRules) {
                        const result = rule(this.item.value);
                        if (typeof result === 'string') {
                            this.valueErrorMessages.push(result);
                            break; // Stop at the first error
                        }
                    }
                }
                                
            },
        }
    }
</script>

<style scoped>
    .customHoverButton:before {
        background-color: unset !important;
        transition: unset !important;
    }

    .customHoverButton {
        background-color: unset !important;
        color: var(--v-primary-base);
    }

        .customHoverButton:hover {
            filter: brightness(80%);
        }
</style>